module.exports = __webpack_public_path__ + "img/honor05.66f54cbc.webp";